import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'spiderWeb',
      d: 'M-2,-4h4v0.5h-4zM-1,-3.5h2v0.5h-2zM-2,-3h1.5v0.5h-1.5zM0.5,-3h1.5v0.5h-1.5zM-2,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1zM-0.5,-1.5h1v0.5h-1zM1,-1.5h1v0.5h-1z',
    },
    {
      paint: 'bird',
      d: 'M-0.5,-3h1v0.5h-1zM-1.5,-2.5h3v0.5h-3zM-1,-2h2v0.5h-2zM-1,-1.5h0.5v0.5h-0.5zM0.5,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 42,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
